Pegasus.UploadController = Ember.ObjectController.extend({
  needs: ['editing', 'modal', 'application', 'imageGallery', 'template'],
  contentBinding: 'controllers.editing.content',

  imageMagickIsWorking: true,

  shouldShowImageReplacerBinding: 'controllers.application.shouldShowImageReplacer',

  shouldShowImageGalleryBinding: 'controllers.application.shouldShowImageGallery',

  isStandalone: function(){
    return window === window.parent;
  }.property(),

  isSizeRestricted: null, // defined by editing states

  isUserGalleryEnabled: function(){
    return Pegasus.get('options.isUserGalleryEnabled');
  }.property('Pegasus.options.isUserGalleryEnabled'),

  didCancelUpload: function(){
    this.cancel();

    this.setProperties({
      dataSrcProxy: '',
      errors: []
    });
  },

  originalDataSrc: null,

  didReplaceImage: function(){
    var validationObject;
    function tryClosing(){
      if( !this.get('errors').length && !this.get('dataSrcTimer') ){
        this.setProperties({
          errors: [],
          dataSrcProxy: ''
        });
      }
    }

    this.setProperties({
      shouldShowLoading: false,
      errors: []
    });

    if( this.get('dataSrc') === this.get('dataSrcProxy') ){
      tryClosing.call(this);
      return;
    }

    if ( !this.get('dataSrcProxy') ){
      this.setProperties({
        errors: [{
          key: 'Invalid URL',
          message: Em.I18n.t( 'editor.upload.error' )
        }]
      });
      return;
    }

    this.set('fileData', {
      upload: {
        'uploadUrl': this.get('dataSrcProxy')
      }
    });

    this.setProperties({
      shouldShowLoading: true
    });
    Pegasus.stateMachine.transitionTo('uploadingImageFromUrl');
  },

  errors: [],

  dataSrcTimer: null,

  dataSrcProxy: function proxy(_, value){
    if( typeof( value ) !== 'undefined' ){
      proxy.store = value;
      return value;
    }
    return proxy.store;
  }.property('dataSrc'),

  shouldShowLoading: false,

  uploadData: null,
  uploadXHR: null,
  fileData: null,
  done: function(data){
    this.set('errors', []);
    Em.run.later( function(){
      $('.replace-overlay.open').removeClass('open');
      Em.run.later( function(){
        Pegasus.lookupController('application').set('shouldShowImageReplacer', false);
      }, 1000);
    }, 1000);

    Pegasus.stateMachine.send( 'didComplete', data);
  },
  fail: function(e, data){
    Pegasus.stateMachine.send( 'errorProcessingImage', data );
  },
  validate: function(name) {
    var testable;

    if ( !name ) {
      return true;
    }

    testable = name.lastIndexOf("/") !== -1 ?
      name.substr( name.lastIndexOf("/"), name.length ) : name;

    if( !/\./.test( testable ) ){ return true; }

    return (/\.(png|jpg|jpeg|gif|bmp)(\?.*)?$/i).test(testable);
  },
  add: function (e, data) {
    this.set('fileData', {
      upload: data
    });

    if(this.validate(data)) {
      this.launchFileUpload(data);
      return true;
    } else {
      Pegasus.stateMachine.send( 'errorProcessingImage', 'extension' );
      return false;
    }
  },

  launchFileUpload: function(data){
    Pegasus.stateMachine.send('didUploadImage');
  },

  _requestComplete: function(event, data) {
    if ( data.encoded ) {
      this.done(data);
    } else {
      this.fail();
    }
  },
  cancel: function(){
    var fd = this.get('fileData');

    if ( fd &&
         fd.upload &&
         fd.upload.abort ) {
      fd.upload.abort();
    }

    Pegasus.stateMachine.send( 'didCancelUpload' );
  }
});
